module.exports = __webpack_public_path__ + "img/logo.36355784.svg";